<section class="pt-navigation-context">
  <dls-tabs class="pt-secondary-navigation">
    <a routerLink="/equipment/devices" routerLinkActive="pt-selected">
      <span>Devices</span>
    </a>
    <a routerLink="/equipment/accessories" routerLinkActive="pt-selected">
      <span>Accessories</span>
    </a>
  </dls-tabs>
</section>
<div class="rules-tab-content">
  <router-outlet></router-outlet>
</div>